var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mx-5 mt-5 mb-12",attrs:{"outlined":""}},[_c('mods',{attrs:{"title":_vm.title,"filters":_vm.filters,"headers":_vm.headers}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }